import type {StateCreator} from 'zustand'
import type {DiffRange} from '@github-ui/diff-lines/types'

export type ComparisonInfo = {
  fullDiff: DiffRange
  selectedRange: DiffRange
  hideWhitespace: boolean
}

export interface ComparisonInfoSlice {
  comparisonInfo: ComparisonInfo
  comparisonInfoActions: {
    updateWhitespace: (newVal: boolean) => void
  }
}

export interface ComparisonInfoSliceOpts {
  baseOid: string
  headOid: string
  selectedCommitRange: {
    baseOid: string | undefined
    headOid: string | undefined
  }
  hideWhitespace: boolean
}

export const createComparisonInfoSlice =
  ({
    baseOid,
    headOid,
    selectedCommitRange,
    hideWhitespace,
  }: ComparisonInfoSliceOpts): StateCreator<ComparisonInfoSlice, [['zustand/devtools', never]]> =>
  set => {
    return {
      comparisonInfo: {
        fullDiff: {
          baseOid,
          headOid,
        },
        selectedRange: {
          baseOid: selectedCommitRange.baseOid ?? baseOid,
          headOid: selectedCommitRange.headOid ?? headOid,
        },
        hideWhitespace,
      },
      comparisonInfoActions: {
        updateWhitespace: (newVal: boolean) =>
          set(
            (prevState: ComparisonInfoSlice) => ({
              comparisonInfo: {
                ...prevState.comparisonInfo,
                hideWhitespace: newVal,
              },
            }),
            undefined,
            'comparisonInfo#updateWhitespace',
          ),
      },
    }
  }
